import { createSlice } from '@reduxjs/toolkit'

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    activeTheme: 'Jyrney',
  },
  reducers: {
    setTheme(state, action) {
      state.activeTheme = action.payload
    },
  },
})

export const { setTheme } = themeSlice.actions

export default themeSlice.reducer
